<template>
  <div role="main" class="main-hs321">

    <app-carousel></app-carousel>

    <app-customers></app-customers>

    <app-contacts></app-contacts>

  </div>
</template>

<script>
import Carousel from '@/components/parts/Carousel.vue'
import Customers from '@/components/parts/Customers.vue'
import Contacts from '@/components/parts/Contacts.vue'

export default {
  data () {
    return {
      msg: ''
    }
  },
  components: {
    AppCarousel: Carousel,
    AppCustomers: Customers,
    AppContacts: Contacts
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    margin-top: 113px;
  }
  @media (max-width: 991.98px) {
  .main-hs321 {
    margin-top: 113px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/Main.vue